import { useMutation } from '@src/hooks'
import { DashboardService } from '@src/domain/services'
import { useDispatch, useSelector, dashboardActions } from '@src/store'
import { useEffect } from 'react'
import { useSpinner } from '@src/components/spinner'


export function DashboardViewModel() {
  const dispatch = useDispatch()
  const { spinner } = useSpinner()

  const { mutate: getStatistics } = useMutation(DashboardService.getStatistics)

  useEffect(() => {
    const init = async () => {
      const statisticsDto = await spinner(getStatistics())

      dispatch(
        dashboardActions.setStatisticsInfo(statisticsDto)
      )
    }

    init()
  }, [])

  const { statisticsInfo } = useSelector(state => state.dashboard)

  return { statisticsInfo }
}

export type IDashboardViewModel = ReturnType<typeof DashboardViewModel>
